/* 
 Funktionalitäten dieser Datei: 
   - Beim Klick auf eine Varianten-Bild (Farbe) innerhalb einer ProductCard wird das Bild geändert.
*/

function changeVariant(event, clickedVariant, hoverImage) {
  
  // Verhindere das Standardverhalten des Links
  event.preventDefault();

  // Beim Klick auf inaktive Variante
  if (!$(clickedVariant).hasClass("selected") && !$(clickedVariant).hasClass("soldout") ) {
    
    // Finde die nächstgelegene .ProductCard ausgehend von der geklickten Variante
    const productCard = clickedVariant.closest('.etx-card.ProductCard');

    if (productCard) {
      const allVariants = productCard.querySelectorAll('.variant');
        allVariants.forEach(variant => {
          $(variant).removeClass('selected');
      });
      $(clickedVariant).addClass("selected");

      // Aktualisiere den href-Link der Produktkarte
      const newHref = clickedVariant.getAttribute('data-href');
      
      productCard.setAttribute('href', newHref);

      const primaryMedia = $(productCard).find(".primary-img .Media");
      const clickedVariantMediaClone = $(clickedVariant).find(".Media").clone();

      primaryMedia.replaceWith(clickedVariantMediaClone);
    }
  }
}